export default {
	namespaced: true,
	state: () => ({
		tabIndex: 0,
		OrderIntroDetailShow: false,
		currentOrderInfo: {},
		currentProductInfo: {},
		userInfo: {},
		noDataPage: false,
	}),
	mutations: {
		setTabIndex(state, data) {
			state.tabIndex = data;
		},
		setOrderIntroDetailShow(state, data) {
			state.OrderIntroDetailShow = data;
		},
		setCurrentOrderInfo(state, data) {
			state.currentOrderInfo = data;
		},
		setCurrentProductInfo(state, data) {
			state.currentProductInfo = data;
		},
		setUserInfo(state, data) {
			state.userInfo = data;
		},
		setNoDataPage(state, data) {
			state.noDataPage = data;
		},
	},
	getters: {
		tabIndex(state) {
			return state.tabIndex;
		},
		OrderIntroDetailShow(state) {
			return state.OrderIntroDetailShow;
		},
		currentOrderInfo(state) {
			return state.currentOrderInfo;
		},
		currentProductInfo(state) {
			return state.currentProductInfo;
		},
		userInfo(state) {
			return state.userInfo;
		},
		noDataPage(state) {
			return state.noDataPage;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Mall/modules/index.js